import { atom } from 'jotai';
import type { AuthSource } from '~/modules/user/type';
export const uiStateAtomLoginModalOpened = atom(false);
/**
 * True while the open login modal was auto-opened by the site-gate page-view
 * prompt. Gates LoginPromptDismissed so modals opened from other entry points
 * (header, sheet CTAs, enquiry) never log a prompt dismissal.
 */
export const uiStateAtomLoginModalOpenedByPrompt = atom(false);
export const uiStateAtomLoginModalAuthSource = atom<AuthSource | null>(null);
export const uiStateAtomLoginModalRedirect = atom<string | undefined>(
    undefined,
);
export const uiStateAtomLoginModalTitle = atom<string | undefined>(undefined);
